import "../../../sass/pages/_welcome-message.scss";

export default function SubmitMessage() {
  return (
    <div className="welcome-message">
      <h2>Your form has been sussesfully sent!!</h2>
      <p>Please check your email, our team will contact you for the next steps.</p>
    </div>
  );
}